if (!window.__shoespray_variantSwatchesLoaded) {
  window.__shoespray_variantSwatchesLoaded = true;

  const { fetchProductsInChunks } = window.storefrontApi.createNodesChunkedProductsService({
    query: window.storefrontApi.PRODUCT_DATA_SWATCHES_PDP,
    chunkSize: 25,
    flushDelay: 30,
  });

  const SELECTORS = {
    // Rerendering selectors
    GALLERY_WRAPPER: '[data-replaceable-gallery]',
    PRODUCT_HEADER: '[data-replaceable-product-header]',
    BUY_BUTTONS: '[data-replaceable-buy-buttons]',
    PRODUCT_NOTICE: '[data-replaceable-product-notice]',
    LOW_STOCK_MESSAGE: '[data-replaceable-low-stock-message]',
    VARIANT_SELECTS: '[data-replaceable-variants]',
    ACCORDIONS: '[data-replaceable-accordion]',
    BREADCRUMBS: '[data-replaceable-breadcrumbs]',
    SIZE_RECOMMENDATION: '[data-replaceable-size-recommendation]',
    DYNAMIC_SECTIONS: '#MainContent .main-product-section ~ .shopify-section',

    // Cart MVP
    CART_ITEM_MEDIA: '[data-replaceable-cart-item-media]',
    CART_ITEM_DETAILS: '[data-replaceable-cart-details]',
    CART_NOTICE: '[data-replaceable-edit-color-cart-notice]',
    CART_LOW_STOCK_MESSAGING: '[data-replaceable-edit-color-cart-low-stock-messaging]',
    CART_LINE_LOW_STOCK: '[data-replaceable-cart-line-low-stock]',
    CART_MOBILE_IMAGE: '[data-replaceable-edit-cart-image]',

    COMPLETE_WITH_SECTION: '[data-replaceable-complete-with-section]',
    COMPLETE_WITH_CARD: '[data-replaceable-complete-with-card]',
    COMPLETE_WITH_CARD_CHECKBOX: '[data-replaceable-complete-with-card] input[type="checkbox"]',
    COMPLETE_WITH_CARD_REFERENCE: '[data-replaceable-complete-with-card-reference]',
    COMPLETE_WITH_MOBILE_IMAGE: '[data-replaceable-complete-with-image]',
    COMPLETE_WITH_MODAL_CONTENT: '[data-replaceable-complete-with-modal]',
    COMPLETE_WITH_MOBILE_IMAGE_REFERENCE: '[data-replaceable-complete-with-image-reference]',
    COMPLETE_WITH_VARIANTS_REFERENCE: '[data-replaceable-complete-with-variants-reference]',
    COMPLETE_WITH_VARIANTS: '[data-replaceable-complete-with-variants]',
    COMPLETE_WITH_SUBMIT_REFERENCE: '[data-replaceable-complete-with-submit-reference]',
    COMPLETE_WITH_SUBMIT: '[data-replaceable-complete-with-submit]',

    // Data selectors
    SWATCH_INPUTS: 'input[data-mvp-variant-handle]',
    PHOTOSWIPE_GALLERY: '[data-mvp-photoswipe-media-gallery]',
    PHOTOSWIPE_GALLERY_DOTS: '[data-mvp-slider-dots]',
    SLIDER_MOBILE_GUTTER: '[data-mvp-slider-mobile]',
    MEDIA_ITEM: '[data-mvp-product-media-item]',
    MEDIA_IMAGE: '[data-mvp-thumbnail-img]',
    MEDIA_LIST: '[data-mvp-product-media-list]',
    DEFERRED_MEDIA: '[data-mvp-deferred-media]',
    MEDIA_TOGGLE_BUTTON: '[data-mvp-product-media-toggle]',
    PRODUCT_SECTION: '[data-mvp-product-section]',
    SWATCH_COLOR_LABEL: '[data-mvp-color-label]',
    COLOR_CART_PROPERTY: '[data-mvp-color-cart-property]',
    DATA_SELECTED_VARIANT: '[data-selected-variant]',
    DATA_VARIANTS_JSON: '[type="application/json"][data-variants]',

    // Data Attributes
    SWATCH_VARIANT_HANDLE_ATTRIBUTE: 'data-mvp-variant-handle',
    SWATCH_COLOR_LABEL_ATTRIBUTE: 'data-color-label',
    SWATCH_PRODUCT_ID_ATTRIBUTE: 'data-product-id',
    SWATCH_SKU_ATTRIBUTE: 'data-variant-sku',
    MVP_TYPE_PRODUCT: 'main-product',
    MVP_TYPE_COMPLETE_WITH: 'complete-with',
    MVP_TYPE_EDIT_CART: 'edit-cart',

    // Classes
    SWATCH_UNAVAILABLE: 'is-unavailable',
    HIDDEN: 'hidden',
    COMPLETE_WITH_TRIGGERS: 'complete-with__triggers',
    VARIANTS_LOADING: 'is-loading',
    SWATCH_CHECKED: 'is-checked',
    ADD_TO_CART_CLASS: 'product-form__submit-button',
    PRODUCT_FORM_INPUT: 'product-form__input',
    GRID_SELECTOR_LABEL: 'grid-selector__label',
    GRID_SELECTOR_INPUT: 'grid-selector__input',
    COLOR_VALUE_WRAPPER: 'color-selector-item',

    // IDs
    SIZE_FIELDSET_SELECTOR: '[data-size-option-fieldset]',
  };

  const { parseHTMLString, replaceElementAttributes, safeParseJSON } = window.utilities;

  /**
   * Selected swatches are styled via `.color-selector.is-checked` on the label,
   * not `:checked` alone. Keep label class in sync with the radio state.
   */
  function syncCheckedColorSwatchStyles(scope) {
    const root = scope?.querySelectorAll ? scope : document;
    root.querySelectorAll('.color-selector-item').forEach((item) => {
      const label = item.querySelector('.color-selector');
      const input = item.querySelector('.color-selector__radio');
      if (!label || !input) return;

      const isChecked = input.checked;
      label.classList.toggle(SELECTORS.SWATCH_CHECKED, isChecked);
      input.setAttribute('aria-checked', isChecked ? 'true' : 'false');
    });
  }

  window.syncCheckedColorSwatchStyles = syncCheckedColorSwatchStyles;

  const getCookieValue = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  };
  /**
   * Publish click event on the size option that is preselected by default (for validation removal)
   */
  function setSizeSelectedValueListener() {
    const sizeOptionValue = document.querySelector(
      `#data-replaceable-variants ${SELECTORS.SIZE_FIELDSET_SELECTOR} .${SELECTORS.GRID_SELECTOR_INPUT}:checked + .${SELECTORS.GRID_SELECTOR_LABEL}`,
    );

    sizeOptionValue?.addEventListener(
      'click',
      () => {
        publish(PUB_SUB_EVENTS.sizeSelectedOptionClick);
      },
      { once: true },
    );
  }

  class VariantUpdater {
    constructor(viewModel) {
      this.viewModel = viewModel;
      this.productSection = viewModel?.$productSection;
      this.loadingClassTimeout = null;
      this.updateSelectedVariant();
      this.subscribeToVariantChange();
    }

    updateSelectedVariant() {
      syncCheckedColorSwatchStyles(this.productSection || document);
    }

    addLoadingState() {
      this.viewModel?.$variant_selects?.classList.add(SELECTORS.VARIANTS_LOADING);

      clearTimeout(this.loadingClassTimeout);
      this.loadingClassTimeout = setTimeout(() => {
        this.viewModel?.$variant_selects.classList.remove(SELECTORS.VARIANTS_LOADING);
      }, 2000);
    }

    removeLoadingState() {
      clearTimeout(this.loadingClassTimeout);
      this.viewModel?.$variant_selects?.classList.remove(SELECTORS.VARIANTS_LOADING);
      setSizeSelectedValueListener();
    }

    subscribeToVariantChange() {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        this.removeLoadingState();

        // log pixel view
        const swatch = document.querySelector('input.color-selector__radio.is-checked');
        if (swatch !== null) {
          const fullProdId = swatch.getAttribute(SELECTORS.SWATCH_PRODUCT_ID_ATTRIBUTE).split('/');
          const prodId = fullProdId.length ? fullProdId[fullProdId.length - 1] : null;
          if (prodId != null) {
            window.propelSearchProvider.tracker.logPageView({
              cookie2: decodeURIComponent(getCookieValue('_br_uid_2') ?? ''),
              type: 'product',
              productId: prodId,
              productName: window.brProduct.title,
              sku: event.data.variant?.id,
            });

            // trigger event for new shopify pixel implementation here
            window.Shopify.analytics.publish('br_pixel_product_view', {
              prod_id: prodId,
              prod_name: window.brProduct.title,
              sku: event.data.variant?.id,
            });
          }
        }
      });
    }

    applyVariantSelections(newVariantSelectsHTML, handle) {
      this.addLoadingState();
      const selectedVariant = this.getSelectedVariant();
      const $newVariantSelects = this.replaceVariantSelectMarkup(newVariantSelectsHTML, handle);

      if (selectedVariant) {
        const optionValueIds = this.getOptionValueIdsFromValues(selectedVariant.options, $newVariantSelects);
        if (optionValueIds.length) {
          this.publishSelectionChange(optionValueIds, handle);
        }
      }
    }

    getSelectedVariant() {
      const raw = this.productSection?.querySelector(SELECTORS.DATA_SELECTED_VARIANT)?.innerHTML;
      return safeParseJSON(raw);
    }

    replaceVariantSelectMarkup(newHTML, handle) {
      const parsedHTML = parseHTMLString(newHTML);

      this.productSection.updateOptionValues(parsedHTML);
      this.productSection.dataset.url = window.Shopify.routes.root + `products/${handle}`;

      return parsedHTML;
    }

    getOptionValueIdsFromValues(values, $variantSelectsRoot) {
      const ids = [];
      const groups = [...$variantSelectsRoot.querySelectorAll(`.${SELECTORS.PRODUCT_FORM_INPUT}`)];

      for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        const valueToMatch = values[i];
        let input =
          valueToMatch && group
            ? group.querySelector(`input[type="radio"][value="${valueToMatch}"]:not(.is-unavailable):not([disabled])`)
            : null;

        // When switching products via swatch, the color value won't match (e.g. "Black" vs "White").
        // Fall back to the new product's default for that option so we can still restore size.
        if (!input) {
          input =
            group?.querySelector('input[type="radio"]:checked') ||
            group?.querySelector('input[type="radio"]:not(.is-unavailable):not([disabled])');
        }

        if (!input?.dataset?.optionValueId) return [];
        ids.push(input.dataset.optionValueId);
      }

      return ids;
    }

    publishSelectionChange(optionValueIds, handle) {
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: {},
          target: {
            dataset: {
              productUrl: window.Shopify.routes.root + `products/${handle}`,
            },
          },
          selectedOptionValues: optionValueIds,
          force: true,
        },
      });
    }
  }

  class VariantDataStore {
    constructor(scope) {
      this.$scope = scope;
      this.handles = [];
      this.dataMap = {};
      this.imageCache = new Map();

      window.variantDataCache = window.variantDataCache || {};
    }

    async fetchVariant(handle) {
      // Check global cache first
      if (window.variantDataCache[handle]) {
        this.dataMap[handle] = window.variantDataCache[handle];
        return this.dataMap[handle];
      }

      // Check local cache next
      if (this.dataMap[handle]) return this.dataMap[handle];

      const response = await fetch(window.Shopify.routes.root + `products/${handle}`);
      const html = await response.text();

      const dom = parseHTMLString(html);

      // The cart-drawer is rendered in the theme layout and contains its own
      // `[data-replaceable-cart-item-media]` (one per cart line). Strip it from
      // the parsed PDP DOM so that selectors like CART_ITEM_MEDIA resolve to the
      // `edit-color-cart-reference` block (which reflects the *target* variant)
      // rather than the existing cart contents.
      dom.querySelector('cart-drawer')?.remove();

      const data = {
        product_header: dom.querySelector(SELECTORS.PRODUCT_HEADER)?.innerHTML,
        accordions: dom.querySelector(SELECTORS.ACCORDIONS)?.innerHTML,
        breadcrumbs: dom.querySelector(SELECTORS.BREADCRUMBS)?.innerHTML,
        dynamicSections: dom.querySelectorAll(SELECTORS.DYNAMIC_SECTIONS),
        variant_selects: dom.querySelector(SELECTORS.VARIANT_SELECTS)?.innerHTML,
        galleryHTML: dom.querySelector(SELECTORS.GALLERY_WRAPPER)?.innerHTML,
        buyButtons: dom.querySelector(SELECTORS.BUY_BUTTONS)?.innerHTML,
        productNotice: dom.querySelector(SELECTORS.PRODUCT_NOTICE)?.innerHTML,
        lowStockMessage: dom.querySelector(SELECTORS.LOW_STOCK_MESSAGE)?.innerHTML,
        sizeRecommendation: dom.querySelector(SELECTORS.SIZE_RECOMMENDATION)?.innerHTML,
        photoSwipeDots: dom.querySelector(SELECTORS.PHOTOSWIPE_GALLERY_DOTS)?.innerHTML,
        images: [...dom.querySelectorAll(`${SELECTORS.GALLERY_WRAPPER} ${SELECTORS.MEDIA_IMAGE}`)].map(
          (img) => img.src,
        ),
        completeWithCardReference: dom.querySelector(SELECTORS.COMPLETE_WITH_CARD_REFERENCE)?.innerHTML,
        completeWithCard: dom.querySelector(SELECTORS.COMPLETE_WITH_CARD)?.innerHTML,
        completeWithSection: dom.querySelector(SELECTORS.COMPLETE_WITH_SECTION)?.innerHTML,
        completeWithModalContent: dom.querySelector(SELECTORS.COMPLETE_WITH_MODAL_CONTENT)?.innerHTML,
        completeWithMobileImage: dom.querySelector(SELECTORS.COMPLETE_WITH_MOBILE_IMAGE_REFERENCE)?.innerHTML,
        completeWithVariants: dom.querySelector(SELECTORS.COMPLETE_WITH_VARIANTS_REFERENCE)?.innerHTML,
        completeWithSubmit: dom.querySelector(SELECTORS.COMPLETE_WITH_SUBMIT_REFERENCE)?.innerHTML,
        cartItemMedia: dom.querySelector(SELECTORS.CART_ITEM_MEDIA)?.innerHTML,
        cartItemDetails: dom.querySelector(SELECTORS.CART_ITEM_DETAILS)?.innerHTML,
        cartColorNotice: dom.querySelector(SELECTORS.CART_NOTICE)?.innerHTML,
        cartColorLowStock: dom.querySelector(SELECTORS.CART_LOW_STOCK_MESSAGING)?.innerHTML,
        cartLineLowStock: dom.querySelector(SELECTORS.CART_LINE_LOW_STOCK)?.innerHTML,
        cartColorMobileImage: dom.querySelector(SELECTORS.CART_MOBILE_IMAGE)?.innerHTML,
        variantsJson: dom.querySelector(SELECTORS.DATA_VARIANTS_JSON)?.textContent,
      };

      this.dataMap[handle] = data;
      window.variantDataCache[handle] = data;

      this.cacheImages(data.images);
      return data;
    }

    async fetchAllVariants() {
      const promises = this.handles.map((handle) => this.fetchVariant(handle));
      await Promise.all(promises);
    }

    getVariant(handle) {
      return this.dataMap[handle] || null;
    }

    cacheImages(imageUrls = []) {
      imageUrls.forEach((url) => {
        if (!this.imageCache.has(url)) {
          const img = new Image();
          img.src = url;
          this.imageCache.set(url, img);
        }
      });
    }
  }

  class MVPViewEditCart {
    constructor(scope) {
      this.$scope = scope;
      this.viewModel = this.getViewModel();
    }

    getViewModel() {
      return {
        $swatchInputs: this.$scope.querySelectorAll(SELECTORS.SWATCH_INPUTS),
        $swatchColorLabel: this.$scope.querySelector(SELECTORS.SWATCH_COLOR_LABEL),
      };
    }

    getDynamicViewModel(swatch) {
      const modal = swatch.closest('modal-slideout');
      const cartItemHolder = document
        .querySelector(`edit-cart-color[data-modal-id="${modal?.id}"]`)
        ?.closest('.cart-item__holder');

      return {
        $sizeInput: cartItemHolder?.querySelector('edit-cart-size'),
        $cartColorLowStock: modal.querySelector(SELECTORS.CART_LOW_STOCK_MESSAGING),
        $cartLineLowStock: cartItemHolder?.querySelector(SELECTORS.CART_LINE_LOW_STOCK),
        $cartColorNotice: modal.querySelector(SELECTORS.CART_NOTICE),
        $cartColorMobileImage: modal.querySelector(SELECTORS.CART_MOBILE_IMAGE),
        $cartItemMedia: cartItemHolder?.querySelector(SELECTORS.CART_ITEM_MEDIA),
        $cartItemDetails: cartItemHolder?.querySelector(SELECTORS.CART_ITEM_DETAILS),
      };
    }

    updateView(data, swatch) {
      const {
        $cartColorLowStock,
        $cartLineLowStock,
        $cartColorNotice,
        $cartItemMedia,
        $cartItemDetails,
        $cartColorMobileImage,
      } = this.getDynamicViewModel(swatch);

      if (data.cartItemMedia && $cartItemMedia) $cartItemMedia.innerHTML = data.cartItemMedia;

      if (data.cartItemDetails && $cartItemDetails) $cartItemDetails.innerHTML = data.cartItemDetails;

      if (data.cartColorLowStock && $cartColorLowStock) $cartColorLowStock.innerHTML = data.cartColorLowStock;

      if (data.cartLineLowStock && $cartLineLowStock) $cartLineLowStock.innerHTML = data.cartLineLowStock;

      if (data.cartColorNotice && $cartColorNotice) $cartColorNotice.innerHTML = data.cartColorNotice;

      if (data.cartColorMobileImage && $cartColorMobileImage)
        $cartColorMobileImage.innerHTML = data.cartColorMobileImage;
    }
  }

  class MVPViewCompleteWith {
    constructor(scope) {
      this.$scope = scope;
      this.viewModel = this.getViewModel();
    }

    getViewModel() {
      return {
        $completeWithCard: document.querySelector(SELECTORS.COMPLETE_WITH_CARD),
        $completeWithCheckbox: document.querySelector(SELECTORS.COMPLETE_WITH_CARD_CHECKBOX),
        $swatchInputs: this.$scope.querySelectorAll(SELECTORS.SWATCH_INPUTS),
        $swatchColorLabel: this.$scope.querySelector(SELECTORS.SWATCH_COLOR_LABEL),
        $productSection: document.querySelector(SELECTORS.PRODUCT_SECTION),
        $completeWithMobileImage: document.querySelector(SELECTORS.COMPLETE_WITH_MOBILE_IMAGE),
        $completeWithVariants: document.querySelector(SELECTORS.COMPLETE_WITH_VARIANTS),
        $completeWithSubmit: document.querySelector(SELECTORS.COMPLETE_WITH_SUBMIT),
      };
    }

    updateCompleteWithCard(completeWithCard, $completeWithCard) {
      if (completeWithCard && $completeWithCard) {
        const wasChecked = $completeWithCard.querySelector('input[type="checkbox"]')?.checked;
        const isSizeExists = $completeWithCard.querySelector('.complete-with__size-trigger');
        $completeWithCard.innerHTML = completeWithCard;

        // For now we don't need to keep checked state when size exist.
        if (wasChecked && !isSizeExists) {
          $completeWithCard.querySelector('input[type="checkbox"]').checked = true;
        }
      }
    }

    updateView(data) {
      const { $completeWithCard, $completeWithMobileImage, $completeWithVariants, $completeWithSubmit } =
        this.viewModel;

      this.updateCompleteWithCard(data.completeWithCardReference, $completeWithCard);

      if (data.completeWithMobileImage && $completeWithMobileImage)
        $completeWithMobileImage.innerHTML = data.completeWithMobileImage;

      if (data.completeWithVariants && $completeWithVariants)
        $completeWithVariants.innerHTML = data.completeWithVariants;

      if ($completeWithSubmit && data.completeWithSubmit) $completeWithSubmit.innerHTML = data.completeWithSubmit;
    }
  }

  class MVPView {
    constructor(scope) {
      this.$scope = scope;
      this.viewModel = this.getViewModel();
      this.galleryUpdater = new GalleryUpdater(this.viewModel);
      this.VariantUpdater = new VariantUpdater(this.viewModel);
    }

    getViewModel() {
      return {
        $product_header: document.querySelector(SELECTORS.PRODUCT_HEADER),
        $accordions: document.querySelector(SELECTORS.ACCORDIONS),
        $breadcrumbs: document.querySelector(SELECTORS.BREADCRUMBS),
        $variant_selects: document.querySelector(SELECTORS.VARIANT_SELECTS),
        $gallery: document.querySelector(SELECTORS.GALLERY_WRAPPER),
        $photoSwipeGallery: document.querySelector(SELECTORS.PHOTOSWIPE_GALLERY),
        $photoSwipeGalleryDots: document.querySelector(SELECTORS.PHOTOSWIPE_GALLERY_DOTS),
        $sliderMobileGutter: document.querySelector(SELECTORS.SLIDER_MOBILE_GUTTER),
        $swatchInputs: this.$scope.querySelectorAll(SELECTORS.SWATCH_INPUTS),
        $buyButtons: document.querySelector(SELECTORS.BUY_BUTTONS),
        $lowStockMessage: document.querySelector(SELECTORS.LOW_STOCK_MESSAGE),
        $sizeRecommendation: document.querySelector(SELECTORS.SIZE_RECOMMENDATION),
        $productSection: document.querySelector(SELECTORS.PRODUCT_SECTION),
        $swatchColorLabel: this.$scope.querySelector(SELECTORS.SWATCH_COLOR_LABEL),
        $colorCartProperty: this.$scope.querySelector(SELECTORS.COLOR_CART_PROPERTY),
        $completeWithCard: document.querySelector(SELECTORS.COMPLETE_WITH_CARD),
        $completeWithSection: document.querySelector(SELECTORS.COMPLETE_WITH_SECTION),
        $completeWithModalContent: document.querySelector(SELECTORS.COMPLETE_WITH_MODAL_CONTENT),
      };
    }

    updateBuyButtons(newBuyButtons) {
      const { $buyButtons, $productSection } = this.viewModel;
      const parsedBuyButtons = parseHTMLString(newBuyButtons);

      // When product was swapped and buy buttons rerendered - get back validation state if it was on (see product-form.js - showValidationError)
      if ($productSection?.classList.contains('is-error')) {
        const submitButton = parsedBuyButtons.querySelector('[type="submit"]');
        const submitButtonText = submitButton.querySelector('.shared-button__leading-label');

        submitButton?.classList.add('product-form__submit-button--is-error');
        submitButtonText.textContent = window.variantStrings.select_size;
      }

      $buyButtons.innerHTML = parsedBuyButtons.innerHTML;
    }

    updateCompleteWithCard(completeWithCard, $completeWithCard) {
      if (completeWithCard && $completeWithCard) {
        $completeWithCard.innerHTML = completeWithCard;

        // Set default text with price for ATC button
        document.querySelector('add-to-cart-button')?.setDefaultTextValue();
      }
    }

    updateView(data, handle) {
      const {
        $accordions,
        $product_header,
        $gallery,
        $photoSwipeGallery,
        $sliderMobileGutter,
        $completeWithModalContent,
        $completeWithSection,
        $lowStockMessage,
        $sizeRecommendation,
        $breadcrumbs,
      } = this.viewModel;

      if (data.product_header && $product_header) $product_header.innerHTML = data.product_header;
      if (data.buyButtons) this.updateBuyButtons(data.buyButtons);
      if (data.galleryHTML) {
        this.galleryUpdater.updateGallery($gallery, data.galleryHTML);
        $photoSwipeGallery?.initGallery();
        $sliderMobileGutter?.bindElements();
        $sliderMobileGutter?.initPages();
      }

      if (data.completeWithModalContent && $completeWithModalContent)
        $completeWithModalContent.innerHTML = data.completeWithModalContent;

      this.updateCompleteWithCard(data.completeWithSection, $completeWithSection);

      if (typeof data.variantsJson === 'string') {
        const variantsScript = document.querySelector(SELECTORS.DATA_VARIANTS_JSON);
        if (variantsScript) {
          variantsScript.textContent = data.variantsJson;
        }
      }

      if (data.variant_selects) {
        this.VariantUpdater.applyVariantSelections(data.variant_selects, handle);
      }

      if ($lowStockMessage && data.lowStockMessage) {
        $lowStockMessage.innerHTML = data.lowStockMessage;
      }

      if ($sizeRecommendation && data.sizeRecommendation !== undefined) {
        $sizeRecommendation.innerHTML = data.sizeRecommendation || '';
      }

      if ($accordions && data.accordions) {
        $accordions.innerHTML = data.accordions;
      }

      if ($breadcrumbs && data.breadcrumbs) {
        $breadcrumbs.innerHTML = data.breadcrumbs;
      }

      if (data.dynamicSections?.length) {
        const $dynamicSections = [...document.querySelectorAll(SELECTORS.DYNAMIC_SECTIONS)];
        const $mainContent = document.getElementById('MainContent');

        window.Recs?.refreshRecommendations?.unmountAll?.();
        window.PdpRecs?.refreshPdpRecommendations?.unmountAll?.();

        $dynamicSections.forEach((section) => section.remove());

        data.dynamicSections.forEach((newSection) => {
          $mainContent.append(newSection);
        });

        window.Recs?.refreshRecommendations?.mountRecommendations?.();
        window.PdpRecs?.refreshPdpRecommendations?.mountPdpRecommendations?.();

        //Reset Sticky Sizes
        const wrapperSizeDOM = document.querySelector('.product__info-wrapper variant-selects');
        if (wrapperSizeDOM) wrapperSizeDOM.parentElement.style.height = '';
        window.sizeIntersectionPDP && window.sizeIntersectionPDP();
      }
    }
  }

  class GalleryUpdater {
    constructor(viewModel) {
      this.viewModel = viewModel;
    }

    updateGallery(gallery, newGalleryHTML) {
      const parsedHTML = parseHTMLString(newGalleryHTML);
      const newMediaItems = this.getNewMediaItems(parsedHTML);
      const oldMediaItems = gallery.querySelectorAll(SELECTORS.MEDIA_ITEM);
      const mediaList = gallery.querySelector(SELECTORS.MEDIA_LIST);

      this.updatePhotoSwipeDots(parsedHTML);
      this.updateMediaItems(newMediaItems, oldMediaItems, mediaList);
      this.removeOldMediaItems(newMediaItems, oldMediaItems);
    }

    getNewMediaItems(parsedHTML) {
      return [...parsedHTML.querySelectorAll(SELECTORS.MEDIA_ITEM)];
    }

    updatePhotoSwipeDots(parsedHTML) {
      const newDots = parsedHTML.querySelector(SELECTORS.PHOTOSWIPE_GALLERY_DOTS);

      if (newDots) {
        this.viewModel.$photoSwipeGalleryDots.innerHTML = newDots.innerHTML;
      }
    }

    updateMediaItems(newMediaItems, oldMediaItems, mediaList) {
      newMediaItems.forEach((newMediaItem, index) => {
        const newImg = newMediaItem.querySelector(SELECTORS.MEDIA_IMAGE);
        const newDeferredMedia = newMediaItem.querySelector(SELECTORS.DEFERRED_MEDIA);
        const newToggleButton = newMediaItem.querySelector(SELECTORS.MEDIA_TOGGLE_BUTTON);
        const oldMediaItem = oldMediaItems[index];

        if (oldMediaItem) {
          // Video item should be replaced completely
          if (newDeferredMedia || oldMediaItem?.querySelector(SELECTORS.DEFERRED_MEDIA)) {
            this.replaceOldMediaItemWithNew(oldMediaItem, newMediaItem);
          } else {
            this.updateExistingMediaItem(oldMediaItem, newMediaItem, newImg, newToggleButton);
          }
        } else {
          mediaList.appendChild(newMediaItem);
        }
      });
    }

    replaceOldMediaItemWithNew(oldMediaItem, newMediaItem) {
      oldMediaItem.outerHTML = newMediaItem.outerHTML;
    }

    updateExistingMediaItem(oldMediaItem, newMediaItem, newImg, newToggleButton) {
      const existingImg = oldMediaItem.querySelector(SELECTORS.MEDIA_IMAGE);
      const existingToggleButton = oldMediaItem.querySelector(SELECTORS.MEDIA_TOGGLE_BUTTON);
      replaceElementAttributes(existingImg, newImg);
      replaceElementAttributes(oldMediaItem, newMediaItem);

      if (existingToggleButton) {
        existingToggleButton.outerHTML = newToggleButton.outerHTML;
      }
    }

    removeOldMediaItems(newMediaItems, oldMediaItems) {
      if (newMediaItems.length < oldMediaItems.length) {
        oldMediaItems.forEach((oldMediaItem, index) => {
          if (index >= newMediaItems.length) {
            oldMediaItem.remove();
          }
        });
      }
    }
  }

  class BaseMVPHandler {
    constructor(component) {
      this.component = component;
      this.component.handleList = [];
    }

    async initialize() {
      throw new Error('Must implement initialize()');
    }

    isProductAvailable(productData) {
      if (!productData) return false;

      if (typeof productData.totalInventory === 'number' && productData.totalInventory > 0) {
        return true;
      }

      const variantEdges = Array.isArray(productData.variants?.edges) ? productData.variants.edges : [];
      return variantEdges.some(({ node }) => node?.availableForSale === true);
    }

    processSwatchUpdates(productsData) {
      const { viewModel, handleList } = this.component;

      let checkedSwatch = null;
      let hasAvailableSwatch = false;

      viewModel.$swatchInputs.forEach((swatch) => {
        const productId = swatch.getAttribute(SELECTORS.SWATCH_PRODUCT_ID_ATTRIBUTE);
        if (productsData[productId] && productsData[productId].variants) {
          const sku = productsData[productId].variants.edges[0].node.sku;

          if (sku) {
            swatch.setAttribute(SELECTORS.SWATCH_SKU_ATTRIBUTE, sku);
          }
        }

        const productData = productsData[productId];

        if (swatch.checked || swatch.classList.contains('is-checked')) checkedSwatch = swatch;

        if (productData) {
          swatch.setAttribute(SELECTORS.SWATCH_VARIANT_HANDLE_ATTRIBUTE, productData.handle);
          handleList.push(productData.handle);

          if (this.isProductAvailable(productData)) {
            hasAvailableSwatch = true;
            this.component.setSwatchVisible(swatch);
          }
        }
      });

      if (!hasAvailableSwatch && checkedSwatch) {
        checkedSwatch.classList.add(SELECTORS.SWATCH_UNAVAILABLE);
        this.component.disableAddToCart();
      }
    }

    attachSwatchListeners() {
      this.component.viewModel.$swatchInputs.forEach((swatch) => {
        const sku = swatch.getAttribute(SELECTORS.SWATCH_SKU_ATTRIBUTE);

        if (
          swatch.classList.contains(SELECTORS.SWATCH_CHECKED) &&
          !swatch.classList.contains(SELECTORS.SWATCH_UNAVAILABLE)
        ) {
          publish(PUB_SUB_EVENTS.swatchChange, {
            sku: sku,
            isUnavailableSwatch: swatch.classList.contains(SELECTORS.SWATCH_UNAVAILABLE),
          });
        }

        swatch.addEventListener('change', () => {
          const handle = swatch.getAttribute(SELECTORS.SWATCH_VARIANT_HANDLE_ATTRIBUTE);

          if (handle && (!swatch.classList.contains(SELECTORS.SWATCH_CHECKED) || swatch.checked)) {
            this.selectVariant(handle, swatch);
          }

          publish(PUB_SUB_EVENTS.swatchChange, {
            sku: swatch.getAttribute(SELECTORS.SWATCH_SKU_ATTRIBUTE),
            isUnavailableSwatch: swatch.classList.contains(SELECTORS.SWATCH_UNAVAILABLE),
          });
        });
      });
    }

    selectVariant() {
      throw new Error('Must implement selectVariant()');
    }
  }

  class EditCartMVPHandler extends BaseMVPHandler {
    async initialize() {
      this.component.dataStore = new VariantDataStore(this.component);
      this.component.view = new MVPViewEditCart(this.component);
      this.component.viewModel = this.component.view.getViewModel();

      const productIds = this.component.extractProductIDs();
      const productData = await this.component.fetchProductMetadata(productIds);

      this.processSwatchUpdates(productData);
      this.component.dataStore.handles = this.component.handleList;

      await this.component.dataStore.fetchAllVariants();

      this.attachSwatchListeners();
      syncCheckedColorSwatchStyles(this.component);
    }

    /**
     * Finds a variant that matches the exact selected options string
     * @param {string} selectedOptionsString - e.g., "Regular Regular 6.5"
     * @param {Array} variants - array of variant objects with selectedOptions
     * @returns {object|null} - matched variant node or null
     */
    findExactVariantMatch(selectedOptionsString, variants) {
      const inputOptions = selectedOptionsString.trim().split(/\s+/);

      return (
        variants.find(({ node }) => {
          const variantValues = node.selectedOptions.map((opt) => opt.value);
          if (variantValues.length !== inputOptions.length) return false;

          return inputOptions.every((val, index) => val === variantValues[index]);
        }) || null
      );
    }

    // Overriding method in BaseMVPHandler
    processSwatchUpdates(productsData) {
      const { viewModel, handleList } = this.component;

      viewModel.$swatchInputs.forEach((swatch) => {
        const { $sizeInput } = this.component.view.getDynamicViewModel(swatch);
        const productId = swatch.getAttribute(SELECTORS.SWATCH_PRODUCT_ID_ATTRIBUTE);
        const productData = productsData[productId];

        if (!productData) return;

        const { handle, variants } = productData;

        swatch.setAttribute(SELECTORS.SWATCH_VARIANT_HANDLE_ATTRIBUTE, handle);
        handleList.push(handle);

        const shouldShowSwatch = (() => {
          if ($sizeInput) {
            const selectedOptionsStr = $sizeInput.dataset?.selectedOptions;
            const match = this.findExactVariantMatch(selectedOptionsStr, variants?.edges);

            if (match?.node) {
              swatch.setAttribute('data-variant-id', window.utilities.extractIdFromGid(match.node.id));
              return match.node.availableForSale;
            }

            return false;
          }

          const firstNode = variants?.edges?.[0]?.node;
          if (firstNode) {
            swatch.setAttribute('data-variant-id', window.utilities.extractIdFromGid(firstNode.id));
          }
          return this.isProductAvailable(productData);
        })();

        if (shouldShowSwatch) {
          this.component.setSwatchVisible(swatch);
        }
      });
    }

    selectVariant(handle, swatch) {
      const data = this.component.dataStore.getVariant(handle);

      if (data) {
        this.component.view.updateView(data, swatch);
        this.component.updateSwatchSelection(swatch);
      } else {
        console.warn(`No data found for handle "${handle}"`);
      }
    }
  }

  class CompleteWithMVPHandler extends BaseMVPHandler {
    async initialize() {
      // Delay processing complete with swatches to let main product go first
      await new Promise((resolve) => setTimeout(resolve, 500));

      this.component.dataStore = new VariantDataStore(this.component);
      this.component.view = new MVPViewCompleteWith(this.component);
      this.component.viewModel = this.component.view.getViewModel();

      const productIds = this.component.extractProductIDs();
      const productData = await this.component.fetchProductMetadata(productIds);

      this.processSwatchUpdates(productData);
      this.component.dataStore.handles = this.component.handleList;

      await this.component.dataStore.fetchAllVariants();

      this.attachSwatchListeners();
    }

    // Overriding method in BaseMVPHandler
    processSwatchUpdates(productsData) {
      const { viewModel, handleList } = this.component;
      const completeWithChecked = viewModel.$completeWithCheckbox?.checked;

      let checkedSwatch = null;
      let firstAvailableSwatch = null;

      viewModel.$swatchInputs.forEach((swatch) => {
        const productId = swatch.getAttribute(SELECTORS.SWATCH_PRODUCT_ID_ATTRIBUTE);
        if (productsData[productId] && productsData[productId].variants) {
          const sku = productsData[productId].variants.edges[0].node.sku;

          if (sku) {
            swatch.setAttribute(SELECTORS.SWATCH_SKU_ATTRIBUTE, sku);
          }
        }

        const productData = productsData[productId];

        if (swatch.checked || swatch.classList.contains('is-checked')) checkedSwatch = swatch;

        if (productData) {
          swatch.setAttribute(SELECTORS.SWATCH_VARIANT_HANDLE_ATTRIBUTE, productData.handle);
          handleList.push(productData.handle);

          if (this.isProductAvailable(productData)) {
            firstAvailableSwatch = swatch;
            this.component.setSwatchVisible(swatch);
          }
        }
      });

      // let the swatches be processed and do not control the cart unless checked
      // if the module is not used we don't need to validate the swatches inside it
      if (!completeWithChecked) return;
      // if the selected swatch is not available need to tell the user to pick something else
      if (checkedSwatch && firstAvailableSwatch && firstAvailableSwatch != checkedSwatch) {
        checkedSwatch.classList.add(SELECTORS.SWATCH_UNAVAILABLE);
        this.component.disableAddToCart();
      }
    }

    selectVariant(handle, swatch) {
      const data = this.component.dataStore.getVariant(handle);

      if (data) {
        this.component.view.updateView(data, handle);
        this.component.updateSwatchSelection(swatch);
      } else {
        console.warn(`No data found for handle "${handle}"`);
      }
    }
  }

  class ProductMVPHandler extends BaseMVPHandler {
    async initialize() {
      this.component.dataStore = new VariantDataStore(this.component);
      this.component.view = new MVPView(this.component);
      this.component.viewModel = this.component.view.getViewModel();

      const productIds = this.component.extractProductIDs();
      const productData = await this.component.fetchProductMetadata(productIds);

      this.processSwatchUpdates(productData);
      this.component.dataStore.handles = this.component.handleList;

      await this.component.dataStore.fetchAllVariants();
      this.attachSwatchListeners();
      setSizeSelectedValueListener();
    }

    selectVariant(handle, swatch) {
      const data = this.component.dataStore.getVariant(handle);
      if (data) {
        this.component.view.updateView(data, handle);
        this.updateUrl(handle);
        this.component.updateSwatchSelection(swatch);
      } else {
        console.warn(`No data found for handle "${handle}"`);
      }
    }

    updateUrl(handle) {
      const url = new URL(window.location.href);
      const parts = url.pathname.split('/');
      parts[parts.length - 1] = handle;
      url.pathname = parts.join('/');
      window.history.replaceState(null, '', url.toString());
    }
  }

  class MVPComponent extends HTMLElement {
    constructor() {
      super();
      this.companion_products = safeParseJSON(this.dataset.companionProducts, []);
      this.mvpType = this.dataset.mvpType;
      this.handler = null;

      this.bindInit();
    }

    async bindInit() {
      try {
        await this.initialize();
      } catch (e) {
        console.error('MVPComponent initialization failed:', e);
      }
    }

    async initialize() {
      switch (this.mvpType) {
        case SELECTORS.MVP_TYPE_PRODUCT:
          this.handler = new ProductMVPHandler(this);
          break;
        case SELECTORS.MVP_TYPE_COMPLETE_WITH:
          this.handler = new CompleteWithMVPHandler(this);
          break;
        case SELECTORS.MVP_TYPE_EDIT_CART:
          this.handler = new EditCartMVPHandler(this);
          break;
        default:
          throw new Error('Unknown mvpType');
      }

      await this.handler.initialize();
    }

    extractProductIDs() {
      return this.companion_products.map((cp) => cp.productID);
    }

    async fetchProductMetadata(productIds) {
      const result = await fetchProductsInChunks(productIds);
      const resultConverted = Object.fromEntries(Array.from(result.byId.entries()));

      return resultConverted;
    }

    disableAddToCart() {
      document.querySelectorAll(`.${SELECTORS.ADD_TO_CART_CLASS}`).forEach((addToCartButton) => {
        addToCartButton.setAttribute('disabled', true);
      });
    }

    setSwatchVisible(swatch) {
      swatch.closest(`.${SELECTORS.COLOR_VALUE_WRAPPER}`)?.classList?.remove(SELECTORS.HIDDEN);
    }

    updateSwatchSelection(currentSwatch) {
      const { $swatchColorLabel, $colorCartProperty, $swatchInputs } = this.viewModel;
      const swatchLabel = currentSwatch.getAttribute(SELECTORS.SWATCH_COLOR_LABEL_ATTRIBUTE);

      $swatchInputs.forEach((swatch) => {
        swatch.classList.remove(SELECTORS.SWATCH_CHECKED);
      });
      $swatchColorLabel.innerHTML = swatchLabel;
      if ($colorCartProperty) $colorCartProperty.value = swatchLabel;

      const currentSwatchesList = currentSwatch
        .closest('.color-selector-list')
        .querySelectorAll('.color-selector__radio');

      currentSwatchesList.forEach((element) => {
        if (element == currentSwatch) {
          return;
        }
        const parentElement = element.parentElement;
        element.checked = false;
        element.setAttribute('aria-checked', 'false');
        parentElement.classList.remove(SELECTORS.SWATCH_CHECKED);
      });

      currentSwatch.classList.add(SELECTORS.SWATCH_CHECKED);
      currentSwatch.checked = true;
      currentSwatch.setAttribute('aria-checked', 'true');
      const parent = currentSwatch.parentElement;
      parent.classList.add(SELECTORS.SWATCH_CHECKED);
    }
  }

  customElements.define('mvp-component', MVPComponent);
}
